import "./AboutStyle.css";
import Heading from "../../SubComponents/Heading/Heading";
import { ScreenContext } from "../../Utils/contexts";
import { useContext } from "react";
export default function About() {
  const { isLaptop } = useContext(ScreenContext);
  return (
    <div className="about-div" data-aos="fade-up" id="about">
      <Heading index={1}>About me</Heading>
      <div className="about-section">
        <div className="left-heading-div">
          <p className="about-text">
            Hi, I am a consistent learner and a fellow who believes in the
            practical application of everything that I learn. Currently, I am
            pursuing my{" "}
            <span className="blue-text"> Btech degree from ADGITM (IPU)</span>{" "}
            and have a keen interest in{" "}
            <span className="blue-text">
              {" "}
              Data Structures and a plus programming
            </span>{" "}
            in general.
          </p>
          <p className="about-text">
            As a CS engineer with a
            <span className="blue-text">
              {" "}
              good academic record & intrest in computers
            </span>
            , I've worked on several exciting projects that showcase my
            technical proficiency & creativity.
          </p>
          <p className="about-text">
            Here are some of the technology that I love to work with :{" "}
            <span className="orange-text">
              {" "}
              ReactJS, JavaScript, CSS 3, MUI, Python, Scikit, C++, Java,
              FireBase and FireStore
            </span>
            .
          </p>
          <p className="about-text">
            I love to debug and help out people in
            <span className="blue-text"> finding bugs in their codes</span>. I
            love to execute a{" "}
            <span className="blue-text"> given task with perfection</span> and
            I'm here to contribute my bit to this world of programming.
          </p>
        </div>
        {isLaptop && (
          <div className="right-heading-div">
            <div className="overlay">
              <img
                src="./photograph.jpg"
                alt="Personal-photograph"
                className="photograph"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
